import { createFileRoute } from '@tanstack/react-router'
import { LinkedInApplicants } from '@/features/linkedin-jobs/applicants'

export const Route = createFileRoute(
  '/_authenticated/linkedin-job-list/$linkedinJobId/applicants'
)({
  component: LinkedInApplicants,
})
